import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { userSignUp } from "../api/services";

const SignupPage = () => {
  const [formData, setFormData] = useState({
    phoneNumber: "",
    name: "",
    playingLimit: "",
  });

  const navigate = useNavigate();

  const signupMutation = useMutation({
    mutationFn: userSignUp,
    onSuccess: () => {
      navigate("/home");
    },
    onError: (error) => {
      console.error("Signup error:", error);
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const userData = {
      ...formData,
      playingLimit: parseInt(formData.playingLimit, 10),
    };
    signupMutation.mutate(userData);
  };

  return (
    <div className="max-w-[800px] mx-auto h-screen flex flex-col items-center">
      <div className="w-full p-5 flex justify-center">
        <img src="/logo.png" alt="Logo" className="h-40" />
      </div>

      <form
        onSubmit={handleSubmit}
        className="w-full px-5 flex-1 mt-5 flex flex-col gap-4"
      >
        <div className="flex flex-col gap-2">
          <label className="font-semibold text-gray-700">Phone Number</label>
          <input
            type="tel"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            placeholder="Enter phone number"
            className="py-2 px-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
            required
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="font-semibold text-gray-700">Full Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
            className="py-2 px-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
            required
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="font-semibold text-gray-700">Playing Limit</label>
          <input
            type="number"
            name="playingLimit"
            value={formData.playingLimit}
            onChange={handleChange}
            placeholder="Enter playing limit"
            className="py-2 px-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
            required
          />
        </div>

        <button
          type="submit"
          disabled={signupMutation.isPending}
          className="mt-4 py-3 px-5 rounded text-base font-bold cursor-pointer transition-all duration-300 text-white bg-red-600 hover:bg-red-700"
        >
          {signupMutation.isPending ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default SignupPage;
